import { render, staticRenderFns } from "./ColorpagePage.vue?vue&type=template&id=417adfd1"
import script from "./ColorpagePage.vue?vue&type=script&lang=js"
export * from "./ColorpagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports